<template>
  <div class="h-100">
      <LinkingState :is-logged-in="isLoggedIn" />
      <router-view v-if="isLoggedIn"></router-view>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import Login from './components/Login.vue';
import Search from './components/Search.vue';
import FolderNavigator from './components/FolderNavigator.vue';
import Arborescence from './components/Arborescence.vue';
import LinkingState from './components/LinkingState.vue';
import credentialsStore from './store/credentials-store'
import LysiasApiMixin from './mixins/LysiasApiMixin'

@Component({ components:
        {
            Login,
            Search,
            Arborescence,
            LinkingState,
            FolderNavigator,
        },
        store: credentialsStore
})
export default class App extends LysiasApiMixin
{
  get isLoggedIn(): boolean
  {
    return this.$store.state.currentCabinet != null && this.$store.state.currentCabinet.credentials != null && this.$store.state.currentCabinet.credentials.isLoggedIn;
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}
</style>
